<template>
  <div>
    <h1 class="pl-2 text-2xl font-medium">
      {{ $t("zoom_meeting.report_participant") }}
      {{ generalInfo && generalInfo.zoom_meeting.title }}
    </h1>
    <md-card class="mt-10 mb-10">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">
            {{ $t("zoom_meeting.overall_statistic") }}
          </h4>
        </div>
      </md-card-header>
      <md-card-content class="ml-10 px-0">
        <overall-statistic
          :general-info="generalInfo"
          :static-info="staticInfo"
        >
        </overall-statistic>
      </md-card-content>
    </md-card>
    <md-card class="mt-10">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("zoom_meeting.attendance_log") }}</h4>
        </div>
      </md-card-header>
      <md-card-content class="ml-10 px-0">
        <attendance-log
          :data="attendanceLogInfo"
          :defaultData="attendanceLogInfoDefault"
          :date-selected="dateSelected"
          :currentTimezone="currentTimezone"
          :staticInfo="staticInfo"
          :fromTimeSelected="fromTimeSelected"
          :isScheduleMeeting="true"
          :dateSelectedByQuery="dateSelectedByQuery"
        >
        </attendance-log>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import OverallStatistic from "./OverallStatistic";
import AttendanceLog from "@/pages/ZoomMeeting/Components/AttendanceLog";
import { service_names, service_paths } from "@/constants/Services";
import pick from "lodash/pick";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";
import { mapGetters } from "vuex";

export default {
  components: { OverallStatistic, AttendanceLog },
  data() {
    return {
      attendanceLogInfo: null,
      attendanceLogInfoDefault: null,
      generalInfo: null,
      staticInfo: null,
      listDate: [],
      limitListDate: 10,
      dateSelected: "",
      dateSelectedByQuery: "",
      groupCalendarId: null,
      newDateSelect: "",
      currentTimezone: "",
      fromTimeSelected: "",
      initCpmDropdown: false,
      isoFormat: "YYYY-MM-DD[T]HH:mm:ss",
      serverFormat: "YYYY-MM-DD HH:mm:ss",
      buttonSearch: {
        action: this.fetchAttendanceLog
      },
      cpmKey: null
    };
  },
  computed: {
    zoomId() {
      return this.$route.params.id;
    },
    ...mapGetters("user", ["info"])
  },
  created() {
    this.dateSelectedByQuery = this.$route.query.date;
    this.groupCalendarId = this.$route.query.groupCalendarId;
    this.fetchGeneralInfo();
    this.fetchReportStatic();
  },
  methods: {
    fetchReportByDateTime() {
      this.fetchAttendanceLog({ limit: 1000 });
      this.fetchReportStatic();
    },
    async fetchGeneralInfo() {
      const path = `${service_names.school}/calendars/video-conference/${this.zoomId}?date=${this.dateSelectedByQuery}`;
      const { data } = await this.$axios.get(path);
      this.generalInfo = data;
      this.currentTimezone = data.timezone;
      this.fromTimeSelected = data.from_time;
      this.dateSelected = moment(this.dateSelectedByQuery).format("YYYY-MM-DD");
      await this.fetchAttendanceLog({ limit: 1000 });
    },
    async fetchReportStatic() {
      const path = `${service_names.school}/report-zoom-meeting/${this.zoomId}/report-statistics?date=${this.dateSelectedByQuery}`;
      const { data } = await this.$axios.get(path);
      this.staticInfo = data;
    },
    async fetchAttendanceLog(params) {
      const path = `${service_names.school}/attendance-logs/group-calendar/${this.groupCalendarId}`;
      const { data } = await this.$axios.get(path, { ...params });
      this.attendanceLogInfo = null;
      this.attendanceLogInfoDefault = null;
      this.$nextTick(() => {
        this.setAttendanceLog(cloneDeep(data.data));
      });
    },
    formatTableData(data) {
      let timezoneSchool = this.info?.school?.timezone;
      return data.map(item => {
        return {
          ...item,
          join_time: convertTimeByTimezone(
            item.join_time,
            "Etc/UTC",
            this.currentTimezone || timezoneSchool,
            this.serverFormat
          ),
          leave_time: convertTimeByTimezone(
            item.leave_time,
            "Etc/UTC",
            this.currentTimezone || timezoneSchool,
            this.serverFormat
          )
        };
      });
    },
    setAttendanceLog(data) {
      const getTime12Hour = date => {
        if (!date) return "";
        return moment(date, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
      };
      let baseData = this.formatTableData(data);
      let info = baseData.map(item => {
        return {
          ...pick(item, [
            "calendar_id",
            "description",
            "join_time",
            "leave_time",
            "date",
            "id",
            "status",
            "participant_display_name",
            "class"
          ]),
          ...pick(item?.user_no_sql, [
            "full_name",
            "student_code",
            "avatar_url",
            "email"
          ]),
          from_join_time: getTime12Hour(item.join_time),
          date_join_time: moment(item.join_time).format("YYYY-MM-DD"),
          from_leave_time: getTime12Hour(item.leave_time),
          date_leave_time: moment(item.leave_time).format("YYYY-MM-DD")
        };
      });
      this.attendanceLogInfo = cloneDeep(info);
      this.attendanceLogInfoDefault = cloneDeep(info);
    }
  },
  provide() {
    return {
      fetchReportByDateTime: this.fetchReportByDateTime
    };
  }
};
</script>
